var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "a05bd11fbe22c99201416b5355758e9b9101671e"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["foundation@mdrt"] = {
  id: "a05bd11fbe22c99201416b5355758e9b9101671e"
};